"use client";

import { ReactNode, StrictMode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { UserTypeProvider } from "./UserTypeProvider";
import RecaptchaBadgeProvider from "./RecaptchaBadgeProvider";

const queryClient = new QueryClient();

export default function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <UserTypeProvider>
          <RecaptchaBadgeProvider>
            {children}
          </RecaptchaBadgeProvider>
        </UserTypeProvider>
      </QueryClientProvider>
    </StrictMode>
  );
} 